// extracted by mini-css-extract-plugin
module.exports = {"test":"IntroBox_test__V6QzC","title":"IntroBox_title__1cJvJ","text":"IntroBox_text__1Pkg1"};